const countries = [
  { "name": "Argentina", "dialCode": "+54", "iso": "ar" },
  { "name": "Belize", "dialCode": "+501", "iso": "bz" },
  { "name": "Bolivia", "dialCode": "+591", "iso": "bo" },
  { "name": "Brazil", "dialCode": "+55", "iso": "br" },
  { "name": "Canada", "dialCode": "+1", "iso": "ca" },
  { "name": "Chile", "dialCode": "+56", "iso": "cl" },
  { "name": "Colombia", "dialCode": "+57", "iso": "co" },
  { "name": "Costa Rica", "dialCode": "+506", "iso": "cr" },
  { "name": "Ecuador", "dialCode": "+593", "iso": "ec" },
  { "name": "El Salvador", "dialCode": "+503", "iso": "sv" },
  { "name": "Guatemala", "dialCode": "+502", "iso": "gt" },
  { "name": "Honduras", "dialCode": "+504", "iso": "hn" },
  { "name": "Mexico", "dialCode": "+52", "iso": "mx" },
  { "name": "Nicaragua", "dialCode": "+505", "iso": "ni" },
  { "name": "Panama", "dialCode": "+507", "iso": "pa" },
  { "name": "Paraguay", "dialCode": "+595", "iso": "py" },
  { "name": "Peru", "dialCode": "+51", "iso": "pe" },
  { "name": "United States", "dialCode": "+1", "iso": "us" },
  { "name": "Uruguay", "dialCode": "+598", "iso": "uy" },
  { "name": "Venezuela", "dialCode": "+58", "iso": "ve" }
];

export default countries;
